/**
 * Copies i18n params and resolves `matchTitleKey` (e.g. sports.calcio) into `matchTitle`
 * so notification templates always receive a display-ready title in the viewer's language.
 */
function enrichNotificationParams(t, params) {
  if (!params || typeof params !== 'object' || Array.isArray(params)) return {}
  const next = { ...params }
  if (typeof next.matchTitleKey === 'string' && next.matchTitleKey.trim()) {
    next.matchTitle = t(next.matchTitleKey.trim(), { defaultValue: next.matchTitle || '' })
    delete next.matchTitleKey
  }
  return next
}

/**
 * Renders a notification body using the viewer's current i18n language when
 * `messageI18nKey` / `messageI18nParams` are present; otherwise falls back to `message`.
 */
export function resolveNotificationMessage(t, notification) {
  const key = notification?.messageI18nKey
  const params = notification?.messageI18nParams

  if (typeof key === 'string' && key.trim()) {
    const safeParams = enrichNotificationParams(t, params)
    return t(key.trim(), {
      ...safeParams,
      defaultValue: typeof notification?.message === 'string' ? notification.message : ''
    })
  }

  return typeof notification?.message === 'string' ? notification.message : ''
}

/** Build params for match title: raw DB title or a sport i18n key for untitled matches. */
export function matchTitleI18nParams(match) {
  const raw = (match?.title || '').trim()
  if (raw) return { matchTitle: raw }
  const sportKey = match?.sport === 'calcio' ? 'sports.calcio' : 'sports.padel'
  return { matchTitleKey: sportKey }
}
